import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { supabase } from "@/lib/supabase";

export default function ShortRedirect() {
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let active = true;
    async function resolve() {
      if (!code) { setNotFound(true); return; }
      const { data, error } = await supabase
        .from("listings")
        .select("id")
        .eq("short_code", code.toUpperCase())
        .maybeSingle();
      if (!active) return;
      if (error || !data) { setNotFound(true); return; }
      navigate(`/anuncio/${data.id}`, { replace: true });
    }
    resolve();
    return () => { active = false; };
  }, [code, navigate]);

  if (notFound) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-3 px-6 text-center">
        <h1 className="text-xl font-bold">Anúncio não encontrado</h1>
        <p className="text-muted-foreground">Esse link pode ter expirado ou o anúncio não está mais disponível.</p>
        <button onClick={() => navigate("/")} className="mt-2 px-4 py-2 rounded-md bg-primary text-primary-foreground font-semibold">Ir para o início</button>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="text-muted-foreground">Redirecionando…</p>
    </div>
  );
}
